var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-transition', {
    staticClass: "Loader",
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.enable,
      expression: "enable"
    }],
    class: {
      'Loader-backdrop': _vm.backdrop
    }
  }, [_c('div', {
    staticClass: "Loader-popup"
  }, [_c('div', {
    staticClass: "Loader-body align-self-center"
  }, [_c('div', {
    ref: "lottieLoader"
  })]), _vm.message ? _c('div', {
    staticClass: "body h3",
    class: {
      'text-white': _vm.backdrop
    }
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }